import { CustomFilter, CustomFilterField, CustomFilterOperator, CustomFilterType } from "../Models/CustomFilterModels";
import { Utilities } from "./Utilities";

export enum jqc {
    placeholder_for_promptModals = '#placeholder-for-promptModals',
    promptYesNoModal = '#promptYesNoModal',
    promptModalYesBtn = '#promptModalYesBtn',
    promptModalNoBtn = '#promptModalNoBtn',

    recordListCustomFilterFieldName = 'recordListCustomFilterFieldName',
    recordListCustomFilterOperator = 'recordListCustomFilterOperator',
    recordListCustomFilterSearchValue = 'recordListCustomFilterSearchValue',
    recordListCustomFilterSearchSelectContainer = 'recordListCustomFilterSearchSelectContainer',
    recordListCustomFilterSearchDate = 'recordListCustomFilterSearchDate',
    recordListCustomFilterTrashBtn = 'recordListCustomFilterTrashBtn',
    recordListCustomFilterRow = 'recordListCustomFilterRow',
    recordListCustomFilterRowContainer = 'recordListCustomFilterRowContainer'
}

export class CustomFiltersHelper {
    // ----------------------------------------------------------- //
    // GLOBAL VARS
    private customFilterDefinitions: Array<CustomFilter> = [];
    private containerEl: JQuery<HTMLElement>;
    private customFilterEl: JQuery<HTMLElement>;

    // ----------------------------------------------------------- //
    // PUBLIC FUNCTIONS
    public init = (containerEl: JQuery<HTMLElement>, customFilterEl: JQuery<HTMLElement>, customFilterDefinitions: Array<CustomFilter>): void => {
        const self = this;

        self.containerEl = containerEl;
        self.customFilterEl = customFilterEl;
        self.customFilterDefinitions = customFilterDefinitions;

        self.containerEl.find('[name="recordListCustomFilterRow"]').remove();
    }

    public customFilterAddRow = (onlyAddRowIfCountIs0: Boolean = false): void => {
        const self = this;

        // If set, only add a new row if there are not any already shown
        if (onlyAddRowIfCountIs0 == true) {
            if (self.containerEl.find('[name="' + jqc.recordListCustomFilterRow + '"]').length > 0) return;
        }

        // First, copy from the TEMPLATE element and append the row
        var el = self.customFilterEl.clone(false);
        el.css('display', 'flex');
        self.containerEl.find('[name="' + jqc.recordListCustomFilterRowContainer+'"]').append(el);

        // Get the element names
        var fieldNameEl = el.find('[name="' + jqc.recordListCustomFilterFieldName+'"]');
        var fieldOperatorEl = el.find('[name="' + jqc.recordListCustomFilterOperator+'"]');
        var fieldSearchValueEl = el.find('[name="' + jqc.recordListCustomFilterSearchValue+'"]');
        var fieldSearchSelectContainer = el.find('[name="' + jqc.recordListCustomFilterSearchSelectContainer + '"]');
        var fieldSearchDateEl = el.find('[name="' + jqc.recordListCustomFilterSearchDate+'"]');
        var trashBtn = el.find('[name="' + jqc.recordListCustomFilterTrashBtn+'"]');

        // When the copntrol first loads, add in each of the select options
        self.customFilterDefinitions.forEach(function (f,i) {
            fieldNameEl.append($("<option></option>").attr("value", f.field.fieldName).text(f.field.labelName));
            if (i == 0) {
                f.field.operators.forEach(function (o) {
                    var operatorText = self.getBilingualOperator(o);
                    fieldOperatorEl.append($("<option></option>").attr("value", o).text(operatorText));
                });
            }
        });

        // ON CHANGE EVENTS //
        // When the field name is changed, update the operators
        fieldNameEl.on('change', function () {
            // By default, switch to the txt field. We switch to select later if needed
            fieldSearchDateEl.parent().parent().css('display', 'none');
            fieldSearchSelectContainer.css('display', 'none');
            fieldSearchValueEl.parent().css('display', 'block');

            fieldSearchSelectContainer.empty();
            var fieldSearchSelectEl = $(document.createElement("select"));
            $(fieldSearchSelectEl).attr('class', "w-100 h-100");
            fieldSearchSelectContainer.append(fieldSearchSelectEl);

            // Populate operators
            var field = self.customFilterDefinitions.find(f => f.field.fieldName == $(this).children("option:selected").val()).field;
            populateOperators(field);

            // For certain field names, change the search field to a select box and populate that
            if (field.lutApiEndPoint != null) {
                populateSearchSelect(window.G_SITEFOLDERNAME + '/LUT/GetSimpleLUT/', field.lutApiEndPoint, field.lutKeyField, field.lutDescField, null, function (data: Array<any>) {
                    if (data != null) {
                        //fieldSearchSelectEl.append($("<option></option>"));
                        data.forEach(function (d) {
                            fieldSearchSelectEl.append($("<option></option>").attr("value", d.key).text(d.descr));
                        });
                    }
                    if (field.multiSelect == true) {
                        fieldSearchSelectEl.attr('multiple', 'multiple');
                        (fieldSearchSelectEl as any).val('').multiselect({ buttonWidth: '100%', widthSynchronizationMode: 'always', buttonTextAlignment: 'left' });
                    }
                });
            }
            else if (field.fieldType == CustomFilterType.Boolean) {
                fieldSearchValueEl.parent().css('display', 'none');
                fieldSearchDateEl.parent().parent().css('display', 'none');
                fieldSearchSelectContainer.css('display', 'block');

                var data = [{ key: "", descr: "" }, { key: "true", descr: "True" }, { key: "false", descr: "False" }];
                data.forEach(function (d) {
                    fieldSearchSelectEl.append($("<option></option>").attr("value", d.key).text(d.descr));
                });
            }
            else if (field.fieldType == CustomFilterType.Date) {
                fieldSearchValueEl.parent().css('display', 'none');
                fieldSearchDateEl.parent().parent().css('display', 'block');
                fieldSearchSelectContainer.css('display', 'none');
            }
        });

        // When the trash button is clicked, remove the filter row
        trashBtn.on('click', function () { $(this).parent().parent().remove(); });

        // Functions //
        // Populate the operators
        function populateOperators(field: CustomFilterField) {
            fieldOperatorEl.find('option').remove();
            field.operators.forEach(function (f) {
                var operatorText = self.getBilingualOperator(f);
                fieldOperatorEl.append($("<option></option>").attr("value", f).text(operatorText));
            });
            fieldSearchValueEl.val(null);
        }

        // For select boxes, populate the drop down with LUT values
        function populateSearchSelect(url: string, lutName: string, fieldName: string, descrName: string, descrAltFieldName: string, callback: Function) {
            fieldSearchValueEl.parent().css('display', 'none');
            fieldSearchDateEl.parent().parent().css('display', 'none');
            fieldSearchSelectContainer.css('display', 'block');

            var query = { lutName: lutName, fieldName: fieldName, descrName: descrName, descrAltFieldName: descrAltFieldName };
            Utilities.BlockUI(fieldSearchSelectContainer as any, null, null);
            $.ajax({
                type: "POST",
                url: url,
                data: query,
                success: function (response) {
                    Utilities.UnBlockUI(fieldSearchSelectContainer as any);
                    callback(response);
                },
                error: function (e) {
                    console.log("Error getting LUT", e);
                    Utilities.UnBlockUI(fieldSearchSelectContainer as any);
                    callback(null);
                }
            });
        }

    }

    public customFilterGetFilters = (): CustomFilter[] => {
        const self = this;

        var customFilters: CustomFilter[] = [];
        if (self.containerEl != null) {
            self.containerEl.find('[name="' + jqc.recordListCustomFilterRow + '"]').each(function () {
                var fieldName = $(this).find('[name="' + jqc.recordListCustomFilterFieldName + '"]').val();

                var field = self.customFilterDefinitions.find(f => f.field.fieldName == fieldName).field;
                var operator = $(this).find('[name="' + jqc.recordListCustomFilterOperator + '"]').val() as CustomFilterOperator;

                var searchValue = "";
                if ($(this).find('[name="' + jqc.recordListCustomFilterSearchValue + '"]').parent().css('display') != 'none') {
                    searchValue = $(this).find('[name="' + jqc.recordListCustomFilterSearchValue + '"]').val() as string;
                }
                else if ($(this).find('[name="' + jqc.recordListCustomFilterSearchSelectContainer + '"] select').parent().css('display') != 'none') {
                    searchValue = $(this).find('[name="' + jqc.recordListCustomFilterSearchSelectContainer + '"] select').val().toString();
                    operator = CustomFilterOperator.Or;
                }
                else if ($(this).find('[name="' + jqc.recordListCustomFilterSearchDate + '"]').parent().css('display') != 'none') {
                    searchValue = $(this).find('[name="' + jqc.recordListCustomFilterSearchDate + '"]').val() as string;
                }

                if (field != null && operator != undefined && searchValue != undefined && searchValue != "") {
                    customFilters.push({ field: field, operator: operator, searchValue: searchValue });
                }
            });
        }

        return customFilters;
    }

    private getBilingualOperator = (o: CustomFilterOperator): string => {
        const self = this;
        var opText = Utilities.GetStringFromEnum(CustomFilterOperator, o)

        // If the site is in English, just return the operator text
        if (window.isSiteInWelsh() == false) return opText;

        // IF the site is in welsh, translate
        var outText = "";
        switch (opText) {
            case "Equals":
                outText = "yn hafal i";
                break;
            case "LessThan":
                outText = "Llai na";
                break;
            case "GreaterThan":
                outText = "Yn fwy na";
                break;
            case "Contains":
                outText = "Yn cynnwys";
                break;
            case "Or":
                outText = "Neu";
                break;
            case "NotEquals":
                outText = "Ddim yn hafal i";
                break;
            case "GreaterThanOrEqual":
                outText = "Mwy Na Neu Gyfartal";
                break;
            case "LessThanOrEqual":
                outText = "Llai Na Neu Gyfartal";
                break;
            default:
                outText = opText;
        }

        return outText;
    }
}






